import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

// Language Toggle Props 정의
interface LanguageToggleProps {
  currentLang: "ko" | "en";
  onChange: (lang: "ko" | "en") => void;
}

// 버튼 스타일 정의 (MUI)
const BUTTON_SX = {
  border: 0,
  borderRadius: "999px",
  minWidth: { xs: 66, sm: 78 },
  height: 32,
  px: { xs: 1.25, sm: 1.7 },
  color: "rgba(0, 0, 0, 0.92)",
  fontSize: { xs: "0.74rem", sm: "0.78rem" },
  fontWeight: 700,
  letterSpacing: "-0.01em",
  lineHeight: 1,
  textTransform: "none",
  transition: "all 140ms ease",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.12)",
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg,rgb(232, 232, 232) 0%,rgb(232, 232, 232) 100%)",
    color: "#16355f",
    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.22)",
    "&:hover": {
      background: "linear-gradient(135deg, #ffffff 0%, #dbeafe 100%)",
    },
  },
} as const;

// Language Toggle 함수 
const LanguageToggle: React.FC<LanguageToggleProps> = ({ currentLang, onChange }) => {
  return (
    <ToggleButtonGroup
      value={currentLang}
      exclusive
      onChange={(_event, nextLang) => {
        if (nextLang !== null) {
          onChange(nextLang);
        }
      }}
      aria-label="language toggle"
      sx={{
        border: "2px solid rgba(255, 255, 255, 0.6)",
        borderRadius: "999px",
        p: "3px",
        backdropFilter: "blur(10px)",
        boxShadow:
          "inset 0 1px 1px rgba(255, 255, 255, 0.08), 0 4px 14px rgba(15, 23, 42, 0.16)",
        "& .MuiToggleButtonGroup-grouped": {
          "&:not(:first-of-type)": {
            marginLeft: "3px",
            borderRadius: "999px",
          },
          "&:first-of-type": {
            borderRadius: "999px",
          },
        },
      }}
    >
      <ToggleButton value="ko" sx={BUTTON_SX}>
        한국어
      </ToggleButton>
      <ToggleButton value="en" sx={BUTTON_SX}>
        English
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default LanguageToggle;
